import {useCallback, FormEvent} from 'react';

import {useNavigate, useLocation} from 'react-router-dom';

const RouteController = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleRouteChange = useCallback(
    (event: FormEvent<HTMLInputElement>) => navigate(event.currentTarget.value),
    [navigate]
  );

  return (
    <input
      style={{display: 'none'}}
      id="mobile-bridge-current-route"
      name="mobile-bridge-current-route"
      type="text"
      value={location.pathname}
      onInput={handleRouteChange}
    />
  );
};

export default RouteController;
